import { BottomSheetRoot } from "./root";
import { BottomSheetHandle } from "./handle";
import { BottomSheetHeader } from "./header";
import { BottomSheetBody } from "./body";
import { BottomSheetTitle } from "./title";

export const BottomSheet = {
  Root: BottomSheetRoot,
  Handle: BottomSheetHandle,
  Header: BottomSheetHeader,
  Body: BottomSheetBody,
  Title: BottomSheetTitle,
};

export type { BottomSheetFolds, FoldStep } from "~/hooks/useBottomSheet";
